const LibraryTextWithIcon = ({ icon, text }) => {
	return (
		<div className="d-flex">
			<h5 className="text-book me-2">{icon}</h5>
			<h6 className="pt-1 clamp-1-line" style={{ color: 'var(--sub-text-color)' }}>
				{text}
			</h6>
		</div>
	)
}

export default LibraryTextWithIcon
